import React from 'react'

import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { AppFuelPolicyAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"


export default function AlertsFuelPolicy() {

	const { dataInfo, setDataInfo } = useAlertsDataInfo(alertsDrawerData.peek().fuelPolicy || null)

	return <AppFuelPolicyAutocomplete
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, 'fuelPolicy')}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/fuel`}
	/>

}